import { render, staticRenderFns } from "./CollectionDetailAction.vue?vue&type=template&id=e935facc&"
import script from "./CollectionDetailAction.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetailAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
